import { makeStyles } from "@material-ui/core";

export const BidHistoryContainerStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(1, 0),
  },
}));
